var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogomarkBrandRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 69,
    viewBox: "0 0 48 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7327 0.0697479V12.7381L35.3958 17.849V34.1034L47.2176 27.9321V57.0731L24.088 68.8628L0.958374 57.0731V29.3266L13.2761 23.1022V6.34479L25.7327 0.0697479ZM22.1076 20.8633V28.5344L9.78992 34.9311V51.6621L24.088 58.9501L38.386 51.6621V42.5049L26.5642 48.6763V23.1944L22.1076 20.8633Z",
    fill: "#FA462E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarkBrandRed);
export default __webpack_public_path__ + "static/media/LogomarkBrandRed.d481f28a026ca6ae8225323a7d22beec.svg";
export { ForwardRef as ReactComponent };